import { styled } from "@mui/system";
import React from "react";
import { LocalizedLink as Link } from "gatsby-theme-i18n"
import { useIntl } from "react-intl"
import { ThemeProvider } from "@emotion/react";
import theme from "../theme";
import { CssBaseline, ToggleButton, ToggleButtonGroup } from "@mui/material";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, connectSearchBox } from "react-instantsearch-dom";
import CustomSearchBox from "./CustomSearchBox";
import { useLocalization } from "gatsby-theme-i18n"
import SearchContext from "../tools/context/SearchContext";
import { Helmet } from "react-helmet"
import logo from "../images/logo/logoAppBar.png";

const appId = process.env.GATSBY_ALGOLIA_APP_ID;
const searchKey = process.env.GATSBY_ALGOLIA_SEARCH_KEY;
const searchClient = algoliasearch(appId, searchKey);

const ConnectedSearchBox = connectSearchBox(CustomSearchBox);

/*
** This component is layout for all APP
** but if you need many layout for this APP
** check :
** https://www.gatsbyjs.com/plugins/gatsby-plugin-layout/?=layout
*/

const BottomBar = styled('div')({
  width: '100%',
  height: '70px',
  position: 'absolute',
  bottom: '0px',
  left: '0',
  zIndex: '12000',
})
const DivMenus = styled('ul')({
  width: '800px',
  position: "absolute",
  left: "40%",
  bottom: "21px",
  margin: "0 0 0 -260px",
})
const StyledLi = styled('li')({
  width: "170px",
  float: "left",
  marginRight: "16px",
  borderBottom: "1px solid #8a8a87",
  listStyleType: "none",
  '&:hover, &.Mui-focusVisible': {
    borderBottom: "1px solid black",
  }
})
const StyledLink = styled(Link)({
  color: "#4b4b4b",
  textDecoration: "none",
  '&:hover, &.Mui-focusVisible': {
   color: "black",
  }
})

const SyledExternalLink = styled('a')({
  color: "#4b4b4b",
  textDecoration: "none",
  '&:hover, &.Mui-focusVisible': {
   color: "black",
  }
})

const StyledLiActiv = styled('li')({
  width: "180px",
  float: "left",
  marginRight: "16px",
  borderBottom: "2px solid #4b4b4b",
  color: "#4b4b4b",
  listStyleType: "none",
})
const StyledLinkActiv = styled(Link)({
  color: "#4b4b4b",
  fontWeight: "600",
  textDecoration: "none",
  '&:hover, &.Mui-focusVisible': {
   color: "black",
  }
})
const StyledExternalLinkActiv = styled('a')({
  color: "#4b4b4b",
  fontWeight: "600",
  textDecoration: "none",
  '&:hover, &.Mui-focusVisible': {
   color: "black",
  }
})

const StyledStaticImage = styled('div')({
  width: "200",
  height: "37",
  position: "absolute",
  bottom: "10px",
  left: "34px"
})
const Separator = styled('div')({
  width: "calc(100% - 68px)",
  height: "1px",
  position: "absolute",
  bottom: "69px",
  left: "34px",
  backgroundColor: "#6f6d6a"
})
const DivChildren = styled('main')({
  position: 'relative',
  overflow: 'hidden',
})
const DivToggleGroup = styled(ToggleButtonGroup)({
  position: "absolute",
  bottom: "10px",
  right: "34px",
})
const ButtonLang = styled(ToggleButton)({

})

const MyLayout = ({ children, location }) => {
  const intl = useIntl()
  const {config} = useLocalization()
  const [handleClickSearch, sethandleClickSearch] = React.useState({
    handler: null,
  });

  const valueSearchContext = {
    setHandler: (func) => sethandleClickSearch({handler: func})
  };

  const handleChangeLang = (event, lang) => {
    const path = window.location.href.replace(`/${intl.locale}/`, `/${lang}/`);
    window.location.replace(path)
  }

  const menus = [
    {
      name: intl.formatMessage({ id: "timeline" }),
      url: "/frise",
      color: "#c9d2c0"
    },
    {
      name: intl.formatMessage({ id: "portraits" }),
      url: "/portrait",
      color: "#d9dbc4"
    },
    {
      name: intl.formatMessage({ id: "about" }),
      url: "/apropos",
      color: "#daebf7"
    }
  ]

  return (
    <>
      <Helmet
        htmlAttributes={{
            lang: intl.locale,
        }}
      >
        <meta charSet="utf-8" />
        <title>Sciences Po stories</title>
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <SearchContext.Provider value={valueSearchContext}>
          <DivChildren>
            {children}
          </DivChildren>
        </SearchContext.Provider>
        <BottomBar role="banner">
          <InstantSearch
            searchClient={searchClient}
            indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
          >
            <Separator/>
            <nav aria-label="site nav">
              <StyledStaticImage>
                <Link to="/">
                  <img src={logo} alt="Logo Science po"/>
                </Link>
              </StyledStaticImage>
              <DivMenus> 
                {menus.map((e) => (
                  (location.pathname.search(e.url) !== -1) ?
                  <StyledLiActiv key={e.name}>
                      <StyledLinkActiv to={e.url}>
                        {e.name}
                      </StyledLinkActiv>
                    </StyledLiActiv>
                    :
                    <StyledLi key={e.name}>
                      <StyledLink to={e.url}>
                        {e.name}
                      </StyledLink>
                    </StyledLi>
                ))}
                 <Separator/>
                 <StyledLi>
                  <SyledExternalLink href="https://www.sciencespo.fr/150ans/" target="_blank">
                      {intl.formatMessage({ id: "site150ans" })}
                  </SyledExternalLink>
                 </StyledLi>
              </DivMenus>
              {config.length > 1 && 
                <DivToggleGroup
                  exclusive
                  onChange={handleChangeLang}
                  value={intl.locale}
                >
                  {config.map((configItem) => (
                    <ButtonLang key={configItem.code} value={configItem.code} aria-label={intl.formatMessage({ id: "switch" + configItem.code})}>
                      {configItem.code}
                    </ButtonLang>
                  ))}
                </DivToggleGroup>
              }
            </nav>
            <ConnectedSearchBox handleClick={handleClickSearch.handler}/>
          </InstantSearch>
        </BottomBar>
      </ThemeProvider>
    </>
  )
}


export default MyLayout